import React, {useId} from 'react';

function InputProfile({label, type,...props }, ref) {
    const id = useId()
  return (
    <div className="grid sm:grid-cols-3 gap-2">
      {label && (
        <label
          htmlFor={id}
          className=" mb-2  m-5 text-lg font-medium text-gray-900"
        >
          {label}
        </label>
      )}
      <input

        className="block p-2.5 m-5 col-span-2 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 disabled:bg-slate-300 disabled:text-black disabled:placeholder:text-black"
        {...props}
        id={id}
        ref={ref}
      ></input>
    </div>
  );
}


export default React.forwardRef(InputProfile)